<template>
  <v-container class="header-wrapper" fluid>
    <v-row>
      <v-col style="padding-bottom: 2px;">
        <div class="title-wrapper">
          <h1 v-if="!archived" class="page-title">{{title}}</h1>
          <h1 v-else class="page-title"> Archived Tasks</h1>
        </div>
        <v-btn v-if="this.userRole === 'Admin' && !archived" color="accent" style="float: right;" depressed dark @click="newTask">New Task</v-btn>
        <v-btn v-if="archived" color="accent" outlined style="float: right;" @click="clearAll(), $router.push(previousPath)">Active Tasks</v-btn>
        <div v-bind:class="this.userRole === 'Admin' ? 'header-actions-wrapper': 'non-admin-header-actions-wrapper'">
          <div v-bind:class="this.userRole === 'Admin' ? 'header-action': 'non-admin-header-action'">
            <div v-if="!archived">
              <v-tooltip bottom color="secondary">
                <template v-if="this.userRole === 'Admin'" v-slot:activator="{ on }">
                  <v-btn @click="clearAll(), $router.push('/work-orders/archived')"
                         class="text-right"
                         color="accent"
                         small
                         icon
                         dark
                         v-on="on"
                         height="36"
                         width="36">
                    <v-icon>mdi-archive</v-icon>
                  </v-btn>
                </template>
                <span>Archived Tasks</span>
              </v-tooltip>
            </div>
          </div>
          <div v-bind:class="this.userRole === 'Admin' ? 'header-action': 'non-admin-header-action'">
            <v-tooltip bottom color="secondary">
              <template v-slot:activator="{ on }">
                <v-btn @click="toggleExtraFilters"
                       class="text-right"
                       color="accent"
                       small
                       icon
                       dark
                       height="36"
                       width="36"
                       v-on="on">
                  <v-icon>mdi-filter-plus</v-icon>
                </v-btn>
              </template>
              <span>Toggle All Filters</span>
            </v-tooltip>
          </div>
          <div v-bind:class="this.userRole === 'Admin' ? 'header-action': 'non-admin-header-action'">
            <v-tooltip bottom color="secondary">
              <template v-slot:activator="{ on }">
                <v-btn @click="toggleFilters"
                       class="text-right"
                       color="accent"
                       small
                       icon
                       dark
                       height="36"
                       width="36"
                       v-on="on">
                  <v-icon>mdi-filter</v-icon>
                </v-btn>
              </template>
              <span>Toggle Filters</span>
            </v-tooltip>
          </div>
          <div v-bind:class="this.userRole === 'Admin' ? 'header-action': 'non-admin-header-action'">
            <v-tooltip bottom color="secondary">
              <template v-slot:activator="{ on }">
                <v-btn @click="clearAll"
                       class="text-right"
                       color="accent"
                       small
                       icon
                       dark
                       height="36"
                       width="36"
                       v-on="on">
                  <v-icon>mdi-window-close</v-icon>
                </v-btn>
              </template>
              <span>Clear Filters</span>
            </v-tooltip>
          </div>
          <div v-bind:class="this.userRole === 'Admin' ? 'header-action': 'non-admin-header-action'">
            <v-tooltip bottom color="secondary">
              <template v-slot:activator="{ on }">
                <v-btn icon
                       small
                       color="accent"
                       @click="refresh"
                       height="36"
                       width="36"
                       v-on="on">
                  <v-icon>refresh</v-icon>
                </v-btn>
              </template>
              <span>Refresh Tasks</span>
            </v-tooltip>
          </div>
        </div>
      </v-col>
    </v-row>
    <v-expansion-panels v-model="filterPanel"
                        multiple
                        :disabled="disabled">
      <v-expansion-panel>
        <v-expansion-panel-header expand-icon="none"></v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row>
            <v-col lg="12" md="12" sm="12" cols="12" class="filter-wrapper">
              <v-row>
                <v-flex class="filter">
                  <v-autocomplete :items="regions"
                                  v-model="searchRegion"
                                  multiple
                                  clearable
                                  @click:clear="clearRegion"
                                  label="Region"
                                  outlined
                                  flat>
                    <template v-slot:selection="{ index, item }">
                      <span v-if="index < 1"
                            dark
                            label
                            small>
                        {{shortenText(item.text, searchRegion.length)}}
                      </span>

                      <span v-else-if="index === 1"
                            class="overline grey--text text--darken-3 mx-2">
                        +{{ searchRegion.length - 1 }}
                      </span>
                    </template>
                  </v-autocomplete>
                </v-flex>
                <v-flex class="filter">
                  <v-autocomplete :items="workOrdersSearchBar"
                                  v-model="searchWorkOrders"
                                  :search-input.sync="searchWorkOrdersList"
                                  hide-no-data
                                  clearable
                                  @click:clear="clearWorkOrders"
                                  label="Work Orders"
                                  outlined
                                  flat>
                  </v-autocomplete>
                </v-flex>
                <v-flex class="filter">
                  <v-autocomplete clearable
                                  @click:clear="clearGeneral"
                                  :items="generalLocations"
                                  v-model="searchGeneral"
                                  :search-input.sync="searchGeneralList"
                                  class=""
                                  label="Address, Circ. #"
                                  outlined
                                  flat></v-autocomplete>
                </v-flex>
                <v-flex class="filter">
                  <v-autocomplete class=""
                                  :items="status"
                                  v-model="searchStatus"
                                  clearable
                                  @click:clear="clearStatus"
                                  label="Status"
                                  outlined
                                  flat></v-autocomplete>
                </v-flex>
                <v-flex class="filter">
                  <v-autocomplete label="Crew"
                                  v-model="searchCrewLead"
                                  clearable
                                  @click:clear="clearCrewLead"
                                  class=""
                                  :items="crews"
                                  outlined
                                  flat></v-autocomplete>
                </v-flex>

                <v-flex class="filter">
                  <v-autocomplete label="ISD"
                                  v-model="searchISD"
                                  :search-input.sync="searchISDList"
                                  clearable
                                  outlined
                                  flat
                                  @click:clear="clearISD"
                                  class=""
                                  :items="isds">
                  </v-autocomplete>
                </v-flex>
                <v-flex class="filter">
                  <v-autocomplete clearable
                                  @click:clear="clearStartDate"
                                  :items="startDates"
                                  v-model="searchStartDate"
                                  :search-input.sync="searchStartDateList"
                                  class=""
                                  label="Start Date"
                                  outlined
                                  flat></v-autocomplete>
                </v-flex>
                <v-flex class="filter">
                  <v-menu v-model="calendarA"
                          :close-on-content-click="false"
                          transition="scale-transition"
                          offset-y
                          min-width="290px">
                    <v-date-picker v-model="searchFCMP" multiple="multiple"></v-date-picker>
                    <template v-slot:activator="{ on }">
                      <v-text-field v-model="searchFCMP" outlined label="FCMP" readonly v-on="on" clearable @click:clear="clearFCMP"></v-text-field>
                    </template>
                  </v-menu>
                </v-flex>
                <v-flex class="filter">
                  <v-menu v-model="calendarB"
                          :close-on-content-click="false"
                          transition="scale-transition"
                          offset-y
                          min-width="290px">
                    <v-date-picker v-model="searchDCMP" multiple="multiple"></v-date-picker>
                    <template v-slot:activator="{ on }">
                      <v-text-field v-model="searchDCMP" outlined label="DCMP" readonly v-on="on" clearable @click:clear="clearDCMP"></v-text-field>
                    </template>
                  </v-menu>
                </v-flex>
                <v-flex class="filter">
                  <v-autocomplete clearable  @input="searchCPAList = ''"
                                  @click:clear="clearCPA"
                                  :items="cpaList"
                                  v-model="searchCPA"
                                  class=""
                                  :search-input.sync="searchCPAList"
                                  :rules="[rulesCPA.number]"
                                  label="CPA Number"
                                  outlined
                                  flat></v-autocomplete>
                </v-flex>
              </v-row>
            </v-col>
          </v-row>
          <v-row>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel class="second-filter-panel">
        <v-expansion-panel-header expand-icon="none">
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-col lg="12" md="12" sm="12" cols="12" class="filter-wrapper">
            <v-row>
              <v-flex class="filter">
                <v-autocomplete label="Flag"
                                v-model="searchFlagged"
                                clearable
                                @click:clear="clearFlagged"
                                :items="flagList"
                                item-text="text"
                                item-value="value"
                                outlined
                                flat></v-autocomplete>
              </v-flex>
              <v-flex class="filter">
                <v-autocomplete :items="labels"
                                v-model="searchLabel"
                                clearable
                                label="Checklist Label"
                                outlined
                                flat>
                </v-autocomplete>
              </v-flex>
              <v-flex class="filter">
                <v-autocomplete clearable
                                :items="checkedTypeList"
                                v-model="searchCheckedType"
                                class=""
                                label="Checked Type"
                                outlined
                                flat></v-autocomplete>
              </v-flex>
            </v-row>
          </v-col>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-container>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'SearchBar',

  props: {
    title: {
      type: String,
      default: 'Work Orders'
    },
    archived: {
      type: Boolean,
      default: false
    },
    path: {
      type: String,
      default: '/work-orders'
    }
  },
  created () {
    this.loadLabels()
    this.loadRegions()
    this.loadCrews()

    /*    this.loadWorkOrderNumbersSeachBar('1')
        this.loadCPANumbers('1')
        this.loadLocations('1')
        this.loadISDs(new Date().getFullYear())
        this.loadStartDates(new Date().getFullYear())*/

  },
  watch: {
    searchWorkOrdersList(val) {
      if (val !== null) {
        this.loadWorkOrderNumbersSearchBar(val)
      }

    },
    searchCPAList(val) {
      if (val !== null) {
        this.loadCPANumbers(val)
      }

    },
    searchStartDateList(val) {
      if (val != null) {
        this.loadStartDates(val)
      }
    },
    searchGeneralList(val) {
      if (val !== null) {
        this.loadLocations(val)
      }
    },
    searchISDList(val) {
      if (val !== null) {
        this.loadISDs(val)
      }
    },
    path(val, old) {
      if (old === '/work-orders' || old === '/calendar') {
        this.previousPath = old
      }
    }
  },
  data: () => ({
    previousPath: '/work-orders',
    calendarA: false,
    calendarB: false,
    multiple: true,
    rulesCPA: {
      number: value => {
        const pattern = /^(([1-9]*)|(([1-9]*)\.([0-9]*)))$/
        if (pattern.test(value)) return true
        if(value === null || value === undefined) return true
        return 'Not a number'
      }
    },
    filterPanel: [0],
    labelList: null,
    disabled: true,
    flagList: [{text:'PON', value:'PON'}, {text:'ATTN', value:'ATTN'}, {text:'ATTN & PON', value:'BOTH'},{text:'NO FLAG', value:'NONE'}],
    checkedTypeList: ['Complete', 'Required', 'Na', 'In Progress', 'Unchecked'],
    status: ['Initiation', 'Planning', 'Execution', 'FieldComplete','CloseOut'],
    searchObject: {
      searchISD: null,
      searchRegion: [],
      searchStatus: null,
      searchGeneral: null,
      searchCrew: null,
      searchFlagged: null,
      searchLabel: null,
      searchCheckedType: null,
      searchWorkOrders: null,
      searchFCMP: [],
      searchDCMP: [],
      searchCPA: null,
      searchStartDate: null,
      sortOrder: null,
      searchReturn: { pageIndex: 1 }
    },
    selectISD: null,
    selectRegion: [],
    selectStatus: null,
    selectCrewLead: null,
    selectGeneral: null,
    selectFlagged: null,
    selectCheckedType: null,
    selectLabel: null,
    selectWorkOrders: null,
    selectFCMP: [],
    selectDCMP: [],
    selectCPA: null,
    selectStartDate: null,
    // Lists
    searchCPAList: '',
    searchWorkOrdersList: '',
    searchStartDateList: '',
    searchGeneralList: '',
    searchISDList: ''
  }),

  mounted () {
    let width = window.innerWidth
    if (width < 959) {
      this.toggleFilters()
    }
  },

  methods: {
    ...mapActions({
      filterTasks: 'workOrderTask/getTasks',
      clearTask: 'workOrderTask/clearTask',
      loadLabels: 'checklist/loadChecklistLabels',
      loadRegions: 'region/loadRegions',
      loadCrews: 'crew/loadCrews',
      loadWorkOrderNumbersSearchBar: 'workOrder/loadWorkOrderNumbersSearchBar',
      loadLocations: 'workOrderTask/loadLocationList',
      loadISDs: 'workOrderTask/loadISDList',
      loadStartDates: 'workOrderTask/loadStartDateList',
      loadCPANumbers: 'workOrderTask/loadCPANumberList',
      updateSearchObject: 'workOrderTask/updateSearchObject'
    }),
    newTask () {
      this.clearTask()
      this.$router.push('/work-order/task-manager')
    },
    clearISD () {
      this.selectISD = null
      this.search()
    },
    clearRegion () {
      this.selectRegion = []
      this.search()
    },
    clearStatus () {
      this.selectStatus = null
      this.search()
    },
    clearCrewLead () {
      this.selectCrewLead = null
      this.search()
    },
    clearGeneral () {
      this.selectGeneral = null
      this.search()
    },
    clearFlagged () {
      this.selectFlagged = null
      this.search()
    },
    clearCheckedType () {
      this.selectCheckedValue = null
      this.search()
    },
    clearLabel () {
      this.selectLabel = null
      this.search()
    },
    clearWorkOrders () {
      this.selectWorkOrders = null
      this.search()
    },
    clearStartDate () {
      this.selectStartDate = null
      this.search()
    },
    clearFCMP() {
      this.selectFCMP = []
      this.search()
    },
    clearDCMP () {
      this.selectDCMP= []
      this.search()
    },
    clearCPA () {
      this.selectCPA= null
      this.search()
    },
    clearAll () {
      this.selectGeneral = null
      this.selectISD = null
      this.selectStatus = null
      this.selectRegion = []
      this.selectCrewLead = null
      this.selectFlagged = null
      this.selectLabel = null
      this.searchCheckedType = null
      this.selectCheckedValue = null
      this.selectWorkOrders = null
      this.selectFCMP = [],
        this.selectDCMP = [],
        this.selectCPA = null,
        this.selectStartDate = null
      this.searchObject.sortOrder = 'clear'

      this.search()
    },
    search () {
      this.searchObject.searchISD = this.searchISD
      this.searchObject.searchRegion = this.searchRegion
      this.searchObject.searchStatus = this.searchStatus
      this.searchObject.searchCrew = this.searchCrewLead
      this.searchObject.searchGeneral = this.searchGeneral
      this.searchObject.searchFlagged = this.searchFlagged
      this.searchObject.searchCheckedType = this.searchCheckedType
      this.searchObject.searchLabel = this.searchLabel
      this.searchObject.searchWorkOrders = this.searchWorkOrders
      this.searchObject.searchFCMP = this.searchFCMP
      this.searchObject.searchDCMP = this.searchDCMP
      this.searchObject.searchCPA = this.searchCPA
      this.searchObject.searchStartDate = this.searchStartDate
      this.searchObject.pageIndex = 1 // reset index on new searches!

      if (this.userRole === 'Sub Foreman') { // Set sub formean
        this.searchObject.searchSubForeman = this.userId
      }

      if (!this.archived) {
        this.filterTasks(this.searchObject)
        this.updateSearchObject(this.searchObject)
      } else {
        this.updateSearchObject(this.searchObject)
      }
    },
    refresh () {
      this.search()
    },
    toggleFilters () {
      this.toggleFilterClasses()
      if (this.filterPanel.length === 0) {
        this.filterPanel = [0]
      } else {
        this.filterPanel = []
      }
    },
    toggleExtraFilters() {
      if (!this.filterPanel.includes(1)) {
        if (!this.filterPanel.includes(0)) {
          this.toggleFilterClasses()
        }
        this.filterPanel = [0, 1]
      } else {
        this.toggleFilterClasses()
        this.filterPanel = []
      }
    },
    toggleFilterClasses() {
      let toggleWorkOrderFilters = document.getElementById('workorders-toggle-filters')
      if (toggleWorkOrderFilters) {
        toggleWorkOrderFilters.classList.toggle('toggleOff-filters')
      }
      let toggleScheduleFilters = document.getElementById('schedule-toggle-filters')
      if (toggleScheduleFilters) {
        toggleScheduleFilters.classList.toggle('toggleOff-filters')
      }
    },
    shortenText(text, index) {
      if (text.length > 10 && index > 1) {
        return text.substring(0, 7) + '...'
      } else {
        return text
      }
    }
  },
  computed: {

    searchISD: {
      get () {
        return this.selectISD
      },
      set (value) {
        this.selectISD = value
        this.searchObject.sortOrder = ''

        this.search()
      }
    },
    searchCrewLead: {
      get () {
        return this.selectCrewLead
      },
      set (value) {
        this.selectCrewLead = value
        if (value) {
          this.searchObject.sortOrder = ''

          this.search()
        }
      }
    },
    searchRegion: {
      get () {
        return this.selectRegion
      },
      set (value) {
        this.selectRegion = value
        this.searchObject.sortOrder = ''

        this.search()
      }
    },
    searchFCMP: {
      get () {
        return this.selectFCMP
      },
      set(value) {
        if (value === null) {
          value = []
        }
        this.selectFCMP = value
        this.searchObject.sortOrder = ''
        this.search()
      }
    },
    searchDCMP: {
      get () {
        return this.selectDCMP
      },
      set (value) {
        if (value === null) {
          value = []
        }
        this.selectDCMP = value
        this.searchObject.sortOrder = ''

        this.search()
      }
    },
    searchCPA: {
      get () {
        return this.selectCPA
      },
      set(value) {
        this.selectCPA = value
        this.searchObject.sortOrder = ''

        this.search()
      }
    },
    searchStatus: {
      get () {
        return this.selectStatus
      },
      set (value) {
        this.selectStatus = value
        this.searchObject.sortOrder = ''

        this.search()
      }
    },
    searchFlagged: {
      get () {
        return this.selectFlagged
      },
      set (value) {
        this.selectFlagged = value
        this.searchObject.sortOrder = ''

        this.search()
      }
    },
    searchGeneral: {
      get () {
        return this.selectGeneral
      },
      set (value) {
        this.selectGeneral = value
        this.searchObject.sortOrder = ''

        this.search()
      }
    },
    searchWorkOrders: {
      get () {
        return this.selectWorkOrders
      },
      set (value) {
        this.selectWorkOrders = value
        this.searchObject.sortOrder = ''

        this.search()
      }
    },
    searchCheckedType: {
      get () {
        return this.selectCheckedType
      },
      set (value) {
        this.selectCheckedType = value
        if (this.searchLabel !== null && this.searchLabel !== undefined) {
          this.searchObject.sortOrder = ''

          this.search()
        }
      }
    },
    searchLabel: {
      get () {
        return this.selectLabel
      },
      set (value) {
        this.selectLabel = value
        if (this.searchCheckedType !== null && this.searchCheckedType !== undefined) {
          this.searchObject.sortOrder = ''
          this.search()
        }
      }
    },
    searchStartDate: {
      get () {
        return this.selectStartDate
      },
      set (value) {
        this.selectStartDate = value
        this.searchObject.sortOrder = ''

        this.search()
      }
    },
    ...mapGetters({
      regions: 'region/selectList',
      crews: 'crew/selectList',
      isds: 'workOrderTask/isds',
      workOrdersSearchBar: 'workOrder/workOrderNumbersSearchBar',
      generalLocations: 'workOrderTask/generalLocations',
      labels: 'checklist/checklistLabels',
      startDates: 'workOrderTask/startDates',
      userRole: 'user/role',
      userId: 'user/id',
      cpaList: 'workOrderTask/listOfCPAs'
    })
  }
}
</script>
<style>
.header-wrapper {
  width: 100%;
  background-color: #ffffff;
  box-shadow: 0 4px 2px -2px #e7e7e9;
  padding: 4px 16px 0 16px !important;
  border-bottom: 1px solid #e1e1e1;
}

.header-wrapper .v-expansion-panel-header {
  padding: 0;
  min-height: 16px;
}

.header-wrapper .v-expansion-panel--active .v-expansion-panel-header {
  min-height: 16px;
}

.header-wrapper .v-item-group {
  position: inherit;
}

.header-wrapper .v-expansion-panel {
  position: inherit;
}

.header-wrapper .v-expansion-panel-content__wrap {
  padding: 0 !important;
}

.title-wrapper {
  width: 182px;
  height: 36px;
  float: left;
}

.header-actions-wrapper,
.non-admin-header-actions-wrapper {
  width: 260px;
  height: 36px;
  float: right;
}
.non-admin-header-actions-wrapper {
  width: 156px;
}

.header-action,
.non-admin-header-action {
  width: 36px;
  float: right;
  margin-right: 16px;
}

.sort-bar .v-select__selection--comma {
  margin-top: 5px !important;
}

@media only screen and (max-width: 540px) {
  .header-wrapper {
    padding: 0 16px 0 16px;
  }
  .title-wrapper {
    width: 158px !important;
    height: 46px !important;
  }

  .page-title {
    font-size: 28px;
  }

  .header-actions-wrapper,
  .non-admin-header-actions-wrapper {
    width: 100%;
    float: right;
  }
  .header-action,
  .non-admin-header-action {
    width: 25%;
    margin: 0;
    text-align: center;
  }
  .non-admin-header-action {
    width: 33.33%;
  }
  .header-wrapper .v-expansion-panel-header,
  .header-wrapper .v-expansion-panel--active .v-expansion-panel-header {
    min-height: 10px;
  }
}

.filter-wrapper {
  padding: 0 16px 0 16px!important;
}

@media only screen and (max-width: 959px) {
  .filter-wrapper {
    padding: 0 16px 0 16px;
  }
}

.filter-wrapper .v-input .v-label {
  color: #212121;
}

.filter {
  padding: 0 8px 0 8px;
  height: 56px;
  width: 20%;
}

.filter-btn-wrapper {
  padding: 0 12px 0 0;
}

@media only screen and (max-width: 959px) {
  .filter-btn-wrapper {
    padding: 0 12px 16px 12px;
  }
}

.filter-btn {
  width: 100%;
  float: left;
  text-align: center;
}

@media only screen and (max-width: 800px) {
  .filter {
    width: 50%;
  }
}

.filter-wrapper .v-text-field.v-text-field--enclosed .v-text-field__details {
  margin-bottom: 0;
}

.filter-wrapper .v-text-field--outlined .v-input__control .v-input__slot {
  min-height: 36px;
}

.filter-wrapper .v-select.v-text-field--outlined:not(.v-text-field--single-line) .v-select__selections {
  padding: 0;
}
.filter-wrapper .v-text-field--outlined .v-label {
  font-size: 14px !important;
  top: 8px;
}
.filter-wrapper .v-text-field--outlined .v-label--active {
  font-size: 14px !important;
  top: 18px;
}
.filter-wrapper .v-text-field.v-text-field--enclosed .v-input__append-inner {
  margin-top: 7px;
}

.filter-wrapper .v-input {
  font-size: 14px;
}
.second-filter-button {
  margin-left: auto;
  margin-right: auto;
}
.second-filter-panel {
  margin-top: 0px !important;
}
</style>
